import axios from 'axios';
import { showTabs, selectTab } from '../common/tab/tabActions';
import consts from '../consts';
import { setErroAPI, setSuccess } from '../common/toast/toast';
import { reset as resetForm, initialize } from 'redux-form';
import DateFormat from '../common/dateFormat/DateFormat';
import FormatUtils from '../common/formatUtils/FormatUtils';

export function setModoTela(modo, registro = {}) {
    return {
        type: 'MOTORISTA_FOLGA_MODO_TELA',
        payload: {
			modo: modo,
			registro: registro
		}
    };
}

export function initForm(registro = {}) {
    return [
        initialize('motoristaFolgaForm', registro)
    ];
}

export function setFiltro(filtro = {}) {
    return {
        type: 'MOTORISTA_FOLGA_FILTRO',
        payload: {
			filtro: filtro
		}
    };
}

export function setAguardando(aguardando) {
    return {
        type: 'MOTORISTA_FOLGA_SET_AGUARDANDO',
        payload: aguardando
    };
}

export function getLista() {
	return (dispatch, getState) => {
		
		dispatch({
			type: 'MOTORISTA_FOLGA_LISTADO',
			payload: { data: [] }
		});

		dispatch(setAguardando(true));

    	axios.get(`${consts.API_URL}/motoristaFolga?padrao=true
			${getState().motoristaFolga.filtro.periodo ? `&periodo=${getState().motoristaFolga.filtro.periodo}` : ''}
			${getState().motoristaFolga.filtro.data_inicial ? `&data_inicial=${getState().motoristaFolga.filtro.data_inicial}` : ''}
			${getState().motoristaFolga.filtro.data_final ? `&data_final=${getState().motoristaFolga.filtro.data_final}` : ''}
			${getState().motoristaFolga.filtro.id_motorista ? `&id_motorista=${getState().motoristaFolga.filtro.id_motorista}` : ''}
			${getState().motoristaFolga.filtro.placa ? `&placa=${getState().motoristaFolga.filtro.placa}` : ''}
			${getState().motoristaFolga.filtro.id_estado ? `&id_estado=${getState().motoristaFolga.filtro.id_estado}` : ''}
			${getState().motoristaFolga.filtro.id_tipo ? `&id_tipo=${getState().motoristaFolga.filtro.id_tipo}` : ''}
			${getState().motoristaFolga.filtro.id_motivo ? `&id_motivo=${getState().motoristaFolga.filtro.id_motivo}` : ''}
			${getState().motoristaFolga.filtro.id_grupo_veiculo ? `&id_grupo_veiculo=${getState().motoristaFolga.filtro.id_grupo_veiculo}` : ''}
			${getState().motoristaFolga.filtro.id_motorista_grupo ? `&id_motorista_grupo=${getState().motoristaFolga.filtro.id_motorista_grupo}` : ''}
			${getState().motoristaFolga.filtro.geral ? `&geral=${getState().motoristaFolga.filtro.geral}` : ''}
		`).then(resp => {
			dispatch({
		        type: 'MOTORISTA_FOLGA_LISTADO',
		        payload: resp
		    });
			dispatch(setAguardando(false));
		}).catch(e => {
			setErroAPI(e);
			dispatch(setAguardando(false));
		});
	}
}

export function salvar(registro) {
	return async (dispatch, getState) => {
		if (!registro.id) {
			await axios.post(`${consts.API_URL}/motoristaFolga`, {
				...registro,
				id_usuario_inclusao: getState().auth.usuario.id,
				id_usuario_alteracao: getState().auth.usuario.id
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista());
				dispatch(initForm({
					...registro,
					id: resp.data.id
				}));
				dispatch(getListaCidadeSelect());
			}).catch(e => {
				setErroAPI(e);
			});
		} else {
			axios.put(`${consts.API_URL}/motoristaFolga`, {
				...registro,
				id_usuario_alteracao: getState().auth.usuario.id
			}).then(resp => {
				setSuccess('Operação Realizada com sucesso.');
				dispatch(getLista());
				dispatch(setModoTela('lista'));
				dispatch(getListaCidadeSelect());
			}).catch(e => {
				setErroAPI(e);
			});
		}
	};
}

export function excluir(registro, evento) {
    return (dispatch, getState) => {
        axios.delete(`${consts.API_URL}/motoristaFolga?id=${registro.id}&id_usuario_alteracao=${getState().auth.usuario.id}`)
		.then(resp => {
			setSuccess('Operação Realizada com sucesso.');
			dispatch(getLista());
			dispatch(setModoTela('lista'));
			dispatch(getListaCidadeSelect());
		}).catch(e => {
			setErroAPI(e);
		});
    };
}

export function getListaMotorista() {
	return (dispatch, getState) => {
    	axios.get(`${consts.API_URL}/motorista/listarSelect`)
		.then(resp => {			
			dispatch({
				type: 'MOTORISTA_FOLGA_MOTORISTA_SELECT_LISTADO',
		        payload: resp
		    });
		}).catch(e => {
			setErroAPI(e);
		});
	}
}

export function getListaTipo() {
	return (dispatch, getState) => {
    	axios.get(`${consts.API_URL}/motoristaFolgaTipo/listarSelect`)
		.then(resp => {
			dispatch({
				type: 'MOTORISTA_FOLGA_TIPO_SELECT_LISTADO',
		        payload: resp
		    });
		}).catch(e => {
			setErroAPI(e);
		});
	}
}

export function getListaEstado() {
	return (dispatch, getState) => {
    	axios.get(`${consts.API_URL}/motoristaFolgaEstado/listarSelect`)
		.then(resp => {
			dispatch({
				type: 'MOTORISTA_FOLGA_ESTADO_SELECT_LISTADO',
		        payload: resp
		    });
		}).catch(e => {
			setErroAPI(e);
		});
	}
}

export function getListaPlaca() {
	return (dispatch, getState) => {
    	axios.get(`${consts.API_URL}/gestaoVMData/listarPlacas`)
		.then(resp => {			
			dispatch({
				type: 'MOTORISTA_FOLGA_PLACA_SELECT_LISTADO',
		        payload: resp
		    });
		}).catch(e => {
			setErroAPI(e);
		});
	}
}

export function getListaEstadoTroca() {
	return (dispatch, getState) => {
    	axios.get(`${consts.API_URL}/controleTrocaEstado/listarSelect`)
		.then(resp => {
			dispatch({
				type: 'MOTORISTA_FOLGA_ESTADO_TROCA_SELECT_LISTADO',
		        payload: resp
		    });
		}).catch(e => {
			setErroAPI(e);
		});
	}
}

export function getDadosMotoristaDataLake(nomeMotorista, atualizarDados) {
	return (dispatch, getState) => {
		dispatch(setAguardando(true));
    	axios.get(`${consts.API_URL}/controleTroca/buscarDatalake?motorista=${nomeMotorista}`)
		.then(resp => {
			atualizarDados(resp.data);
			dispatch(setAguardando(false));
		}).catch(e => {
			setErroAPI('Erro ao atualizar');
			console.log(e);
			dispatch(setAguardando(true));
			
		});
	}
}

export function getListaCidadeSelect() {
	return (dispatch, getState) => {
    	axios.get(`${consts.API_URL}/controleTroca/cidade`)
		.then(resp => {
			dispatch({
				type: 'MOTORISTA_FOLGA_CIDADE_TROCA_SELECT_LISTADO',
		        payload: resp
		    });
		}).catch(e => {
			setErroAPI(e);
		});
	}
}

export function getListaEmails(idMotoristaFolga) {
	return (dispatch, getState) => {

		dispatch({
			type: 'MOTORISTA_FOLGA_EMAIL_LISTADO',
			payload: { data: [] }
		});

    	axios.get(`${consts.API_URL}/controleTroca/email?id_motorista_folga=${idMotoristaFolga || 0}`)
		.then(resp => {
			dispatch({
				type: 'MOTORISTA_FOLGA_EMAIL_LISTADO',
		        payload: resp
		    });
		}).catch(e => {
			setErroAPI(e);
		});
	}
}

export function enviarEmail(registro, eventoSucesso) {
	return async (dispatch, getState) => {
		await axios.post(`${consts.API_URL}/controleTroca/email`, {
			...registro,
			id_usuario_envio: getState().auth.usuario.id
		}).then(resp => {
			setSuccess('E-mail enviado com sucesso.');
			dispatch(getListaCidadeSelect());
			dispatch(getListaEmails(registro.id_motorista_folga));
			eventoSucesso();
		}).catch(e => {
			setErroAPI(e);
		});
	};
}